import React, { useEffect, useState } from "react";
import { Box, HorizontalStack, VerticalStack, Text, HorizontalGrid } from "@shopify/polaris";
import { MoneyMinor } from "@shopify/polaris-icons";

import { typedFrontendVendorApi } from "@vendor-app/utils/typedFrontendVendorApi";

export const PredictionsGenerated = () => {
  const [loading, setLoading] = useState(true);
  const [predictedOpportunities, setPredictedOpportunities] = useState({
    subscription_opportunities: "--",
    subscription_revenue_opportunity: "--",
    order_opportunities: "--",
    order_revenue_opportunity: "--",
  });

  const getPredictedOpportunitiesData = async () => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      const response = await typedFrontendVendorApi.getReq("/relo-integration/predictions-summary");
      if (response.type === "success") {setPredictedOpportunities(response.body);}
    } catch (error) {
      console.error("Error fetching Relo predicted opportunities data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPredictedOpportunitiesData();
  }, []);

  const StatsContent = ({ value, label }) => {
    return (
      <Box>
        <VerticalStack gap="2" align="center" inlineAlign="center">
          <Text variant="heading2xl" as="p" fontWeight="medium" color={loading ? "subdued" : undefined}>
            {value}
          </Text>
          <Text variant="bodyMd" as="p" color="subdued" fontWeight="regular" truncate>
            {label}
          </Text>
        </VerticalStack>
      </Box>
    );
  };

  return (
    <div
      style={{
        borderRadius: "0.5rem",
        padding: "1.5rem",
        border: "1px solid #a7f3d0",
        background: "linear-gradient(to top, #eff6ff 0%, #ecfdf5 100%)",
      }}
    >
      <VerticalStack gap="6">
        <HorizontalStack gap="4" align="start" blockAlign="center">
          <div
            style={{
              background: "rgba(209, 255, 233, 1)",
              borderRadius: "100%",
              minWidth: "48px",
              minHeight: "48px",
            }}
          >
            <MoneyMinor
              width="24px"
              style={{ display: "block", fill: "rgba(5, 150, 105, 1)", margin: "12px auto" }}
            />
          </div>
          <VerticalStack gap="1" align="start">
            <Text variant="headingLg" fontWeight="semibold" as="p">
              Revenue opportunities
            </Text>
            <Text variant="bodyMd" fontWeight="regular" as="p" color="subdued">
              Predicted opportunities for the next 30 days
            </Text>
          </VerticalStack>
        </HorizontalStack>

        <div style={{ borderRadius: "0.5rem", padding: "2rem", background: "rgba(255, 255, 255, 0.8)" }}>
          <HorizontalGrid
            columns={{ xs: 2, lg: 2, xl: 4 }}
            gap={{ xs: "800", lg: "800", xl: "0" }}
            alignItems="start"
          >
            <StatsContent
              value={predictedOpportunities.order_revenue_opportunity}
              label="Order revenue opportunity"
            />
            <StatsContent value={predictedOpportunities.order_opportunities} label="Orders" />
            <StatsContent
              value={predictedOpportunities.subscription_revenue_opportunity}
              label="Subscription revenue opportunity"
            />
            <StatsContent value={predictedOpportunities.subscription_opportunities} label="Subscriptions" />
          </HorizontalGrid>
        </div>
      </VerticalStack>
    </div>
  );
};
